var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCookies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120.23 122.88",
    width: "32px",
    height: "32px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.18 0c3.3 0 5.98 2.68 5.98 5.98 0 3.3-2.68 5.98-5.98 5.98-3.3 0-5.98-2.68-5.98-5.98.01-3.3 2.68-5.98 5.98-5.98zm1.6 52.08c5.16 7.7 11.69 10.06 20.17 4.85.28 2.9.35 5.86.2 8.86-1.67 33.16-29.9 58.69-63.06 57.02C23.94 121.13-1.59 92.9.08 59.75 1.74 26.59 30.95.78 64.1 2.45c-2.94 9.2-.45 17.37 7.03 20.15-6.78 21.78 8.36 36.03 28.65 29.48zm-69.75-4.29c4.97 0 8.99 4.03 8.99 8.99s-4.03 8.99-8.99 8.99c-4.97 0-8.99-4.03-8.99-8.99s4.03-8.99 8.99-8.99zm28.32 11.46a5.181 5.181 0 010 10.36c-2.86 0-5.18-2.32-5.18-5.18-.01-2.86 2.31-5.18 5.18-5.18zM35.87 80.59a6.32 6.32 0 11-6.32 6.32c0-3.5 2.83-6.32 6.32-6.32zm13.62-48.36c2.74 0 4.95 2.22 4.95 4.95 0 2.74-2.22 4.95-4.95 4.95-2.74 0-4.95-2.22-4.95-4.95s2.22-4.95 4.95-4.95zm26.9 50.57c4.59 0 8.3 3.72 8.3 8.3 0 4.59-3.72 8.3-8.3 8.3-4.59 0-8.3-3.72-8.3-8.3s3.72-8.3 8.3-8.3zm17.48-59.7c3.08 0 5.58 2.5 5.58 5.58s-2.5 5.58-5.58 5.58-5.58-2.5-5.58-5.58 2.5-5.58 5.58-5.58z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#faf7f5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookies);
export default __webpack_public_path__ + "static/media/cookies.a52d41ec97a56cb23091575abf71ca83.svg";
export { ForwardRef as ReactComponent };